import {flickityLib} from '../lazy_modules';
import {OurFeedbackSvc} from '../services/OurFeedbackSvc';

export class FeedbackSlider {
    readonly flicktyPromise: ng.IPromise<any>;
             product: AnimatronProduct;
             theme: 'black' | 'white';
             feedbacks = this.OurFeedbackSvc.getFor(this.product);

    constructor(private $element: ng.IAugmentedJQuery,
                private $q: ng.IQService,
                private OurFeedbackSvc: OurFeedbackSvc) {
        this.flicktyPromise = $q(resolve => loadScripts([flickityLib], resolve));
    }

    $postLink() {
        this.flicktyPromise.then(() => {
            const Flickity = (window as any).Flickity;
            new Flickity(this.$element[0].firstChild, {
                cellSelector: 'feedback-slider .feedback-item',
                prevNextButtons: true,
                wrapAround: true,
                resize: false,
                cellAlign: 'left',
                adaptiveHeight: true,
                setGallerySize: false,
                pageDots: true
            });
        });
    }

    getImageUrl(image: string) {
        return require(`../../images/wave/feedbacks/${image}`);
    }
}

angular.module('animatronApp.feedback').component('feedbackSlider', {
    bindings: {
        theme: '@?',
        product: '<?'
    },
    controller: FeedbackSlider,
    templateUrl: require('feedback-slider.html')
});


// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/feedbackSlider.ts